/* ══════════════════════════════════════════════════════════════
   main.ts — Application Entry Point
   Imports styles & initializes the app
   ══════════════════════════════════════════════════════════════ */

// Import stylesheets in order
import './styles/index.css';
import './styles/glassmorphism.css';
import './styles/animations.css';
import './styles/india-theme.css';
import './styles/responsive.css';
import './styles/charts.css';
import './styles/components.css';
import './styles/world-monitor.css';
import './styles/marketing-site.css';

import { registerAllLocales } from './locales';
import { initI18n } from './utils/i18n';
import { initApp } from './App';
import { renderPWAInstallBanner, initPWAInstall } from './components/PWAInstall';

// Initialize i18n (register 8 languages + detect browser locale)
registerAllLocales();
initI18n();

// Boot the app
initApp();

// ─── PWA: Service Worker Registration ───
if ('serviceWorker' in navigator) {
   window.addEventListener('load', async () => {
      try {
         const registration = await navigator.serviceWorker.register('/sw.js', {
            scope: '/',
         });
         console.info('[PWA] Service worker registered:', registration.scope);

         // Preload critical data after SW is active
         if (registration.active) {
            registration.active.postMessage({ type: 'PRELOAD_CRITICAL' });
         }
         registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
               newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'activated') {
                     newWorker.postMessage({ type: 'PRELOAD_CRITICAL' });
                  }
               });
            }
         });
      } catch (err) {
         console.warn('[PWA] Service worker registration failed:', err);
      }
   });
}

// ─── PWA: Install Prompt Banner ───
const appRoot = document.getElementById('app');
if (appRoot) {
   const bannerContainer = document.createElement('div');
   bannerContainer.innerHTML = renderPWAInstallBanner();
   document.body.appendChild(bannerContainer);
   initPWAInstall();
}
